import { SearchInsideMsg, SearchInsideQuery } from '../autogenerated/ZoomBridge';

export default class SearchInsideClientQuery {
  constructor(searchText) {
    this.searchText = searchText;
  }

  run() {
    return new Promise((onSuccess, onFailure) => {
      const query = new SearchInsideQuery();
      const message = new SearchInsideMsg();
      message.setFilterText(this.searchText);
      query.message = message;
      query.run().then(
        (resp) => {
          onSuccess(resp);
        },
        (failedResp) => {
          onFailure(failedResp);
        }
      );
    });
  }
}
